import { gql } from '@apollo/client';

export const GET_LIST_TEAMS = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetTeamList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on Teams {
        data {
          id
          name
          partner
          limit
          start_date
          end_date
          description
          type
          status
          socmed_account_limit
          profile_pic_document_id
          profile_pic_document {
            ... on Document {
              id
              name
              object_name
              bucket_name
            }
          }
          created_at
          updated_at
          deleted_at
          team_owner {
            ... on User {
              id
              email
              name
              active_status
              default_team_id
              profile_pic_document_id
              profile_pic_document {
                ... on Document {
                  id
                  name
                  object_name
                  bucket_name
                }
              }
              created_at
              updated_at
              deleted_at
            }
          }
        }
      }
    }
  }
`;

export const GET_LIST_TEAM_BY_USER_ID = gql`
  query GetList(
    $user_id: String!
    $where: Map
    $sort: Map
    $offset: Int
    $limit: Int
  ) {
    GetTeamListByUserID(
      user_id: $user_id
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on Teams {
        data {
          id
          name
          partner
          limit
          start_date
          end_date
          status
          type
          socmed_account_limit
          created_at
          updated_at
          deleted_at
          roles {
            ... on PaginationResponse {
              count
            }
            ... on Roles {
              data {
                id
                slug
                name
                created_at
                updated_at
                deleted_at
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_TEAM_BY_ID = gql`
  query GetByID($id: String!) {
    list: GetTeamByID(id: $id) {
      id
      name
      partner
      limit
      start_date
      end_date
      status
      socmed_account_limit
      description
      type
      is_expired
      created_at
      updated_at
      deleted_at
      roles {
        ... on PaginationResponse {
          count
        }
        ... on Roles {
          data {
            id
            slug
            created_at
            updated_at
            deleted_at
          }
        }
      }
      team_owner {
        ... on User {
          id
          email
          name
          active_status
          default_team_id
          created_at
          updated_at
          deleted_at
        }
      }
      profile_pic_document_id
      profile_pic_document {
        ... on Document {
          id
          name
          file_size
          file_type
          object_name
          bucket_name
          url_link
          created_at
          deleted_at
          updated_at
        }
      }
      documents {
        ... on PaginationResponse {
          count
        }
        ... on Documents {
          data {
            id
            name
            file_size
            file_type
            object_name
            bucket_name
            url_link
            created_at
            deleted_at
            updated_at
          }
        }
      }
    }
  }
`;
